import React from 'react';
import { connect } from 'react-redux';

import UserAccount from '../../components/blocks/UserAccount';
import { updateCurrentUser } from '../../store/actions/users';

function UserAccountContainer(props) {
  return <UserAccount {...props} />;
}

const mapStateToProps = (state) => {
  const { user } = state.role;

  return {
    user,
  };
};

const mapDispatchToProps = (dispatch) => ({
  updateUser: (data) => dispatch(updateCurrentUser(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserAccountContainer);
